import { render } from "./TransparencySection.vue?vue&type=template&id=e237457e&scoped=true"
import script from "./TransparencySection.vue?vue&type=script&lang=js"
export * from "./TransparencySection.vue?vue&type=script&lang=js"

import "./TransparencySection.vue?vue&type=style&index=0&id=e237457e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e237457e"]])

export default __exports__